<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-10 14:20:04
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 15:58:26
-->
<template>
  <ux-form
    class="bind-access x-padding-x"
    ref="form"
    :data="formData"
    :rules="rules"
    label-width="80px"
    data-automation="bindAccess"
    :colon="true"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.router.access')">{{ data.name }}</ux-form-item>
    <ux-form-item :label="$t('HT.bindApply.appId')" prop="appId">
      <ux-select
        v-model="formData.appId"
        :options="list"
        :props="{ label: 'name', value: 'id' }"
      ></ux-select>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      formData: {
        id: this.data.id, // 访问策略-id
        appId: '' // 授权应用
        // ip_address: '', // IP列表
      },
      rules: this.$rul.bindApply()
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
